import React from 'react'
// import { numberThumbnail } from 'src/helper/tool'
// import { jumpToUser } from 'src/helper/webviewFun'
import './index.less'
import { isRtl } from 'src/helper/tool'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  onJumpToUser = (item) => {
    if (this.props.type === 'ranking') {
      this.props.onJumpToUser(item.uid)
    }
  }

  render() {
    const { item, index, type, language } = this.props
    return (
      // ranking
      <div
        className={`ranking-item
          ${type === 'ranking' ? 'ranking' : ''}
          ${isRtl(language) ? 'arlang' : ''}`}
      >
        <div className="number-wrap">{ item && (index + 4) }</div>
        <div className="card-wrap">
          <div className="img-wrap" onClick={() => this.onJumpToUser(item)}>
            <img src={ item && (item.countryIcon || item.avatarurl) } />
          </div>
          <div className="text-wrap">
            <p className="name">{ item && (item.countryName || item.nickname) }</p>
            {
              type !== 'ranking'
                ? (<div className="avatar-warp">
                  {
                    item.avatarurlList &&
                    item.avatarurlList.map((avatar) => {
                      return (
                        <div className="avatar-item" key={avatar}>
                          <img src={avatar} />
                        </div>
                      )
                    })
                  }
                </div>) : ''
            }
            {/* 排名tab激活显示ID */}
            {
              type === 'ranking' ? (<p className='id'>ID: {item && item.duid}</p>) : ''
            }
          </div>
        </div>
        <div className="price-wrap">
          <div className="icon-wrap">
            <img src={item.giftIcon} alt="" />
          </div>
          {/* {item && numberThumbnail(item.score)} */}
          {item && item.score}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/ranking-item/index.js